import { Service } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

@Service()
export class TokenProviderService {
    public isActive: boolean = false;

    constructor() { }

    public isAuthLocalStorage() {
        let storage = window.localStorage;
        this.isActive = storage.length > 0;
        return this.isActive;
    }

    public getInfoToken(token: any) {
        const helper = new JwtHelperService();
        const decoded = helper.decodeToken(token);
        return decoded;
    }

    public isTokenExpired(token: string): boolean {
        const helper = new JwtHelperService();
        return helper.isTokenExpired(token);
    }

    public load() {
        return new Promise((resolve, reject) => {
            this.isAuthLocalStorage();
            
            resolve(true);
        });
    }
}
